<template>
<div class="page flex componentPage">
    <div class="halfContainer flex1" style="padding-right:10px">
        <div class="halfTitle">组织架构</div>
        <div class="halfButton">
            <!-- <el-button type="danger" @click="() => this.ChangeMenuState('off')">禁用</el-button>
                    <el-button type="warning" @click="() => this.ChangeMenuState('on')">启用</el-button> -->
            <el-button type="success" @click="addRootIndex">添加一级机构</el-button>
            <el-button type="primary" @click="addSonIndex">添加下级机构</el-button>
        </div>
        <el-tree ref="tree" :expand-on-click-node="false" :data="allMenu" node-key="id" highlight-current show-checkbox :accordion="true" :props="defaultProp" @node-click="nodeClick"></el-tree>
    </div>
    <div class='flex1'>
        <div class="halfContainer" style="padding-left:10px">
            <div class="halfTitle">机构明细</div>
            <el-form :model="form" ref="form" :rules="rules" label-width="100px">
                <el-form-item label="机构名称：" prop="orgName">
                    <el-input placeholder="机构名称" v-model="form.orgName" :disabled="disableControl"></el-input>
                </el-form-item>
                <el-form-item label="机构排序：" prop='orgNo'>
                    <el-input placeholder="机构排序" v-model="form.orgNo" :disabled="disableControl"></el-input>
                </el-form-item>
                <el-form-item label="机构状态：" prop='state'>
                    <el-select v-model='form.state' placeholder="选择机构状态" :disabled="disableControl">
                        <el-option v-for='item in statusList' :key='item.label' :label='item.label' :value='item.value'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="buttonTeam">
                    <el-button type="primary" @click="submit" :loading="submitLoading" :disabled="disableControl">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import base64 from 'js-base64'
export default {
    data() {
        return {
            form: {},
            allMenu: [],
            disableControl: true,
            submitLoading: false,
            controlType: 'add',
            backup:{},
            parOrgId : null,
            statusList:[
              {label:'禁用',value:0},
              {label:'启用',value:1}
          ],
            defaultProp:{
                label:(data,node)=>{
                    let status = data.state == '0'?'[禁]':(data.state=='1'?'[启]':'')
                    return data.orgName+' '+status
                },
                children:'child'
            },
            rules: {
                orgName: [{
                        trigger: "blur",
                        required: true,
                        message: '请输入机构名称'
                    },
                    {
                        trigger: 'blur',
                        max: 16,
                        message: '长度不得超过16个字符'
                    },
                    {
                        whitespace: true,
                        message: '不能包含空格'
                    }
                ],
                orgNo:[
                    {
                        trigger: "blur",
                        required: true,
                        message: '请输入数字菜单序号',
                        validator: (rule, value, callback) => {
                            if (/^([1-9]\d*|0)?$/.test(value)) return callback()
                            return callback(new Error('请输入正确数字序号'))}
                    },
                ],
                state:[
                    {
                        trigger: "change",
                        required: true,
                        message: '请选择菜单状态'
                    }
                ]
            }
        }
    },
    components: {

    },
    methods: {
        showChild(data, node){
            if(data.childrenMenu.length>0) return data.childrenMenu   
        },
        //添加更菜单
        addRootIndex() {
            this.disableControl = false
            this.form = {}
            this.controlType = 'add'
            this.parOrgId  = null
        },
        //添加子菜单
        addSonIndex() {
            if(!this.form.orgName) return this.$message({message:'请选择一个菜单',type:'warning',duration:2000})
            this.controlType = 'add'
            this.parOrgId = this.backup.orgId
            this.form = {}
            this.disableControl = false
        },
        //菜单节点选择
        nodeClick(node,component) {
            console.log(node)
            this.form = {...node}
            this.backup = {...node}
            this.disableControl = false
            this.controlType = 'update'
        },
        async queryMenu(){
            let params = {
                includeUnuse: true
            }
            const rsp = await this.$http.getOrg(params)
            if(rsp.code != 200) return
            this.allMenu = rsp.data
        },
        async submit() {
            if(!await this.$refs['form'].validate) return
            let upDateParams = {
                orgId : this.form.orgId,
                orgName: this.form.orgName,
                orgNo: this.form.orgNo || 0,
                state: this.form.state
            }
            let addParams = {
                orgName: this.form.orgName,
                orgNo: this.form.orgNo || 0,
                state: this.form.state
            }
            let params = this.controlType == 'add'? addParams : upDateParams
            if(this.parOrgId) params.parOrgId = this.parOrgId
            console.log(params,this.controlType)
            let query = this.controlType == 'add'? await this.$http.addOrg(params) : await this.$http.upDateOrg(params)
            let word = this.controlType == 'add'? '新增成功！' : '修改成功！'
            const rsp = await query
            if(rsp.code != 200) return this.$message({message:rsp.message,type:'error'})
            this.$message({message:rsp.message,type:'success'})
            this.queryMenu()

        }
    },
    created() {
        this.queryMenu()
        // this.allMenu = this.$tools.toTreeArray(this.allMenu, 'menuId', 'parentMenuId')
        // this.allMenu = JSON.parse(sessionStorage.getItem('menu'))
        // console.log(this.allMenu)
    }
}
</script>

<style scoped lang='scss'>
.halfTitle {
    color: #6b7074;
    border-bottom: 1px solid #ecf0f1;
    line-height: 42px;
    margin-bottom: 20px;
}
</style>
